const UploadStatus = ({ text, isLoading, isComplete, isError }) => {
  return (
    <div className="upload-item">
      <div className="upload-item-in">
        <div className="file-name">{text}</div>
        <div className="file-btn">
          {isLoading ? (
            <span className="spinner" />
          ) : (
            isComplete && (
              <span className={`ico-invalid ${isError ? 'error' : 'ok'}`}>
                <em className="sr-only">{text}</em>
              </span>
            )
          )}
        </div>
      </div>
    </div>
  );
};

export default UploadStatus;
